var React = require('react');

function Plus (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14 8H8L8 14H6L6 8H0L0 6H6V0L8 0V6L14 6V8Z","fill":"currentColor"}));
}

Plus.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = Plus;

Plus.default = Plus;
